<template>
    <div>
        <el-dialog
            width="700px"
            :close-on-click-modal="false"
            title="工单信息"
            :visible.sync="visible"
            :before-close="close"
        >
            <div class="wrap">
                <el-row type="flex" justify="space-between">
                    <el-col :span="4">
                        <span class="elTag">
                            <img
                                src="./images/workOrderInfoIcon.png"
                                alt
                                class="icon"
                            />
                            <span>工单信息</span>
                        </span>
                    </el-col>
                </el-row>
                <el-row class="tabWrap">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="基本信息" name="1">
                            <el-form
                                v-if="formData"
                                ref="form"
                                :model="formData"
                                :inline="true"
                                label-width="140px"
                            >
                                <el-row>
                                    <el-form-item label="工单流水号：">
                                        <span>{{ formData.orderNum }}</span>
                                    </el-form-item>
                                    <el-form-item label="工单类型：">
                                        <span>{{
                                            formData.type | workOrderTypeText
                                        }}</span>
                                    </el-form-item>
                                    <el-form-item label="新建工单时间：">
                                        <span>{{ formData.createTime }}</span>
                                    </el-form-item>
                                    <el-form-item label="工单状态：">
                                        <span>{{
                                            formData.states
                                                | workOrderStatesText
                                        }}</span>
                                    </el-form-item>
                                </el-row>
                                <el-row>
                                    <el-form-item label="工单回访员工号：">
                                        <span>{{ formData.callSeatNo }}</span>
                                    </el-form-item>
                                    <el-form-item label="工单回访员姓名：">
                                        <span>{{ formData.callSeatName }}</span>
                                    </el-form-item>
                                    <el-form-item label="工单回访时间：">
                                        <span>{{ formData.callTime }}</span>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="个人信息" name="2">
                            <el-row :gutter="20">
                                <el-col>
                                    <el-form
                                        v-if="formData"
                                        ref="form"
                                        :model="formData"
                                        :inline="true"
                                        label-width="140px"
                                    >
                                        <el-row>
                                            <el-form-item label="客户姓名：">
                                                <span>{{
                                                    formData.customerName
                                                }}</span>
                                            </el-form-item>
                                            <el-form-item label="联系方式：">
                                                <span>{{
                                                    formData.customerphone
                                                }}</span>
                                            </el-form-item>
                                            <el-form-item label="联系地址：">
                                                <span>{{
                                                    formData.community
                                                }}</span>
                                            </el-form-item>
                                            <el-form-item
                                                label="服务对象类型："
                                            >
                                                <span>{{
                                                    formData.customerType
                                                        | customerTypeText
                                                }}</span>
                                            </el-form-item>
                                            <el-form-item
                                                label="主要服务人员："
                                            >
                                                <span>{{
                                                    formData.servePersonName
                                                }}</span>
                                            </el-form-item>
                                        </el-row>
                                        <el-row>
                                            <el-form-item label="服务种类：">
                                                <span>{{
                                                    formData.serviceTypeName
                                                }}</span>
                                            </el-form-item>
                                            <el-form-item label="服务产品：">
                                                <span>{{
                                                    formData.serveproductName
                                                }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>

                <el-row type="flex" justify="space-between" class="marginTop">
                    <el-col :span="4">
                        <span class="elTag">
                            <img
                                src="./images/recordIcon.png"
                                alt
                                class="icon"
                            />
                            <span>通话记录</span>
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <div id="waveform" ref="waveform" v-show="audioUrl">
                        <!-- Here be the waveform -->
                    </div>
                </el-row>
                <el-row>
                    <el-button type="text">录音记录</el-button>
                </el-row>
                <el-table
                    v-if="dataList.length"
                    :data="dataList"
                    border
                    highlight-current-row
                    @current-change="handleCurrentChange"
                    style="width: 100%"
                    class="elTable"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="recTime"
                        label="录音开始时间"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="agentExt"
                        label="主叫号码"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="remoteNum"
                        label="被叫号码"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="agentId"
                        label="话务员"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        prop="timeLen"
                        label="通话时长"
                        align="center"
                    ></el-table-column>
                </el-table>
                <el-row type="flex" justify="space-between" class="marginTop">
                    <el-col :span="4">
                        <span class="elTag">
                            <img
                                src="./images/evaluateIcon.png"
                                alt
                                class="icon"
                            />
                            <span>评价</span>
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form
                            :rules="rules"
                            ref="evaluateForm"
                            :model="formData"
                            label-width="80px"
                            class="evaluateForm"
                        >
                            <el-form-item label="评分">
                                <el-input
                                    v-model="formData.cash"
                                    disabled
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="评语">
                                <el-input
                                    type="textarea"
                                    v-model="formData.adviceContent"
                                    disabled
                                ></el-input>
                            </el-form-item>
                            <!-- <el-form-item>
                <el-button type="primary" size="middle" @click="addOpt">提交</el-button>
                <el-button size="middle" @click="resetOpt">重填</el-button>
              </el-form-item> -->
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import WaveSurfer from "wavesurfer.js" //导入wavesurfer.js
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
        },
    },
    watch: {
        id(newVal) {
            if (newVal) {
                this.detailOpt()
            }
        },
    },
    data() {
        return {
            activeName: "1",
            wavesurfer: null,
            formData: {},
            ghocxIp: "192.168.5.5",
            fileName: "",
            dataList: [],
            rules: {
                qualityRes: [
                    {
                        min: 0,
                        max: 50,
                        message: "评分最大50个字符",
                        trigger: "blur",
                    },
                ],
                qualityresdes: [
                    {
                        min: 0,
                        max: 150,
                        message: "评语最大150个字符",
                        trigger: "blur",
                    },
                ],
            },
        }
    },
    computed: {
        audioUrl() {
            return `http://${this.ghocxIp}/downbyname.php?name=${this.fileName}`
        },
    },
    mounted() {
        this.wavesurferInit()
    },
    filters: {
        workOrderStatesText: function (value) {
            let workOrderStatesOptions = [
                {
                    value: "0",
                    label: "待派发",
                },
                {
                    value: "1",
                    label: "待处理",
                },
                {
                    value: "2",
                    label: "待回访",
                },
                {
                    value: "3",
                    label: "已完成",
                },
                {
                    value: "4",
                    label: "待作废",
                },
                {
                    value: "5",
                    label: "已作废",
                },
                {
                    value: "6",
                    label: "已完成",
                },
                {
                    value: "7",
                    label: "异常工单",
                },
            ]
            let label = ""
            if (!value) return ""
            workOrderStatesOptions.forEach((item) => {
                if (item.value == value) {
                    label = item.label
                }
            })
            return label
        },
        workOrderTypeText: function (value) {
            let workOrderTypeOptions = [
                {
                    value: null,
                    label: "民政工单",
                },
                {
                    value: "1",
                    label: "商业工单",
                },
                {
                    value: "2",
                    label: "残联工单",
                },
                {
                    value: "5",
                    label: "文明办工单",
                },
                {
                    value: "6",
                    label: "老干工单",
                },
            ]
            let label = ""
            if (!value) return ""
            workOrderTypeOptions.forEach((item) => {
                if (item.value == value) {
                    label = item.label
                }
            })
            return label
        },
        customerTypeText: function (value) {
            let customerTypeOptions = [
                {
                    value: "1",
                    label: "商业服务对象",
                },
                {
                    value: "3",
                    label: "残联服务对象",
                },
                {
                    value: "4",
                    label: "老干服务对象",
                },
                {
                    value: "6",
                    label: "民政服务对象",
                },
                {
                    value: "8",
                    label: "D类服务对象",
                },
                {
                    value: "10",
                    label: "文明办服务对象",
                },
                {
                    value: "13",
                    label: "军人事务局服务对象",
                },
            ]
            let label = ""
            if (!value) return ""
            customerTypeOptions.forEach((item) => {
                if (item.value == value) {
                    label = item.label
                }
            })
            return label
        },
    },
    methods: {
        wavesurferInit() {
            this.$nextTick(() => {
                this.wavesurfer = WaveSurfer.create({
                    container: this.$refs.waveform,
                    waveColor: "#606266",
                    progressColor: "#409EFF",
                    backend: "MediaElement",
                    mediaControls: true,
                    audioRate: "1",
                    height: "230",
                    barHeight: "1.5",
                })
            })
        },
        detailOpt() {
            this.$http
                .request({
                    url: "/jjyl/servicePgd/info/findServicepgdById",
                    method: "POST",
                    data: {
                        id: this.$props.id,
                        isCall: "2",
                        username: this.$store.state.info.name,
                        belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
                    },
                })
                .then((res) => {
                    const { code, content } = res
                    if (code == "200") {
                        this.formData = content || {}
                        this.dataList = content.list || []
                        this.fileName = this.dataList[0]
                            ? this.dataList[0].fileName
                            : ""
                        console.log("audioUrl", this.audioUrl)
                        this.$nextTick(() => {
                            if (!this.audioUrl) return
                            if (!this.wavesurfer) {
                                this.wavesurferInit()
                            }
                            // this.wavesurfer.load(this.audioUrl)
                        })
                    }
                })
        },
        // 表格选中
        handleCurrentChange(val) {
            this.fileName = val.fileName
        },
        handleClick(e) {
            this.activeName = e.name
        },
        close() {
            this.$emit("update:visible", false)
            this.$emit("close")
            this.activeName = "1"
        },
        // 评价提交
        addOpt() {
            let data = {
                isCall: "2",
                id: this.$props.id,
                username: this.$store.state.info.name,
                qualityRes: this.formData.qualityRes,
                qualityResDes: this.formData.qualityResDes,
                totallen: this.formData.totallen,
                checkman: this.$store.state.info.name,
                belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
            }
            this.$http
                .request({
                    url: "/jjyl/servicePgd/info/Visit",
                    method: "POST",
                    data: data,
                })
                .then((res) => {
                    const { code, content, message } = res
                    if (code == "200") {
                        this.$message(message)
                        this.detailOpt()
                    } else {
                        this.$message.error(message)
                    }
                })
                .catch((err) => {
                    console.log("err", err)
                })
        },
        resetOpt() {
            this.detailOpt()
        },
    },
}
</script>
<style scoped>
.wrap {
    padding: 20px;
    width: 100%;
    height: 100%;
    min-height: 100%;
    background: #ffffff;
    box-sizing: border-box;
}

.icon {
    margin-right: 8px;
    width: auto;
    height: 14px;
}

.tabWrap .el-tabs__nav-wrap::after {
    height: 0;
}

.tabWrap .el-form-item__label {
    color: #000000;
}

.textRight {
    text-align: right;
}

.elTag {
    margin-bottom: 4px;
    padding: 10px 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #409eff;
    color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
}

.elTable {
    margin-bottom: 36px;
}

.evaluateForm >>> .el-form-item {
    margin-bottom: 22px;
}

.marginTop {
    margin-top: 20px;
}
</style>